module.exports = __webpack_public_path__ + "static/media/empty-cart.dd48c351.png";